// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { LazyImageStyle } from "@insite/mobius/LazyImage";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { infoCardStyles } from "@rpsc/App/Widgets/Basic/InfoCard";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, ellipsis, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

infoCardStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        border: 1px solid ${color("common.border")};
        border-radius: 2px;
        overflow: hidden;
        height: 100%;
        padding: 16px;
    `,
};

infoCardStyles.imageWrapperStyles = {
    css: css`
        ${LazyImageStyle} {
            display: flex;
            width: 100%;
            height: 216px;
            padding-bottom: 16px;
            ${xScreen("gt", "xl")} {
                height: 232px;
            }
            ${xScreen("lte", "md")} {
                height: 386px;
            }
            ${xScreen("lte", "xs")} {
                height: 181px;
            }
            picture {
                display: flex;
                height: 100%;
                width: 100%;
            }
            img {
                width: 100%;
                object-fit: cover;
            }
        }
    `,
};

infoCardStyles.content = {
    css: css`
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        gap: 16px;
    `,
};
infoCardStyles.textWrapperStyles = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        background-color: ${({ backgroundColor }: any) => backgroundColor || "transparent"};
    `,
};

infoCardStyles.heading = {
    css: css`
        ${({ showTopicTags }: any) => showTopicTags && ellipsis(2)};
        ${TypographyStyle} {
            line-height: 28px;
            font-size: 20px;
            font-weight: ${fontConfig.weight.bold};
            margin: 0;
        }
    `,
};

infoCardStyles.subHeading = {
    css: css`
        ${({ showTopicTags }: any) => showTopicTags && ellipsis(3)};
        ${TypographyStyle} {
            line-height: 22px;
            font-size: 14px;
            font-weight: ${fontConfig.weight.regular};
            margin: 0;
        }
    `,
};

infoCardStyles.infoCardButton = {
    css: css`
        width: fit-content;
        ${({ showTopicTags }: any) => showTopicTags && "margin-top: auto"};
    `,
};

infoCardStyles.topicTagsWrapper = {
    css: css`
        display: flex;
        gap: 6px;
        align-items: baseline;
    `,
};

infoCardStyles.tagIconStyles = {
    size: 11,
    color: "primary",
    css: css`
        transform: translateY(2px);
        &,
        svg {
            height: 13px;
        }
    `,
};

infoCardStyles.topicLinksWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
    `,
};

infoCardStyles.topicTagLink = {
    typographyProps: {
        css: css`
            & {
                line-height: 17px;
            }
        `,
    },
};
